import mapboxgl from 'mapbox-gl';

const POPUP_WRAP_CLASS = 'DealsMap__hover-popup-wrap';
const ROOT_CLASS = 'DealsMap__hover-popup';
const TITLE_CLASS = 'DealsMap__hover-popup-title';
const ADDRESS_CLASS = 'DealsMap__hover-popup-address';

const stringFromGeoJsonProp = (value: unknown): string => {
    if (typeof value === 'string') return value;
    if (value == null) return '';
    return String(value);
};

const buildHoverPopupRoot = (dealName: string, addressLine: string): HTMLDivElement => {
    const root = document.createElement('div');
    root.className = ROOT_CLASS;
    const titleEl = document.createElement('div');
    titleEl.className = TITLE_CLASS;
    titleEl.textContent = dealName;
    root.appendChild(titleEl);
    if (addressLine !== '') {
        const addressEl = document.createElement('div');
        addressEl.className = ADDRESS_CLASS;
        addressEl.textContent = addressLine;
        root.appendChild(addressEl);
    }
    return root;
};

export class DealHoverPopupController {
    private popup: mapboxgl.Popup | null = null;

    show(map: mapboxgl.Map, feature: mapboxgl.GeoJSONFeature): void {
        this.remove();
        const geometry = feature.geometry as GeoJSON.Point | undefined;
        if (!geometry || geometry.type !== 'Point') return;
        const [lng, lat] = geometry.coordinates;
        const props = feature.properties;
        const dealName = stringFromGeoJsonProp(props?.dealName);
        const addressLine = stringFromGeoJsonProp(props?.addressLine);

        const content = buildHoverPopupRoot(dealName, addressLine);
        this.popup = new mapboxgl.Popup({
            closeButton: false,
            closeOnClick: false,
            anchor: 'left',
            offset: [20, -25],
            maxWidth: '280px',
            className: POPUP_WRAP_CLASS,
        })
            .setLngLat([lng, lat])
            .setDOMContent(content)
            .addTo(map);
    }

    remove(): void {
        this.popup?.remove();
        this.popup = null;
    }
}
